import React, { useState, useEffect } from 'react';
import './style.sass';
import { useHistory } from 'react-router-dom';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito'
import { Header } from 'pages/Header'
import { ModalError } from 'components/Error/ErrorModal'
import { CheckStatusCard } from 'components/Credito/CheckStatusCard';
import { NextCardButton } from 'components/Credito/NextCardButton'
import { RemoveCardSears } from 'components/Credito/RemoveCard'

import { useConsultaSaldoData } from 'hooks/useConsultaSaldoData'
import { encodeStorage, removeStorage } from 'functions/storageBase64'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'
import { PagarPlan } from 'components/Credito/ButtonPayCard'
import { Points } from 'components/Credito/Points'
import { dataLayerButtons } from 'functions/dataLayerFunction'
import { Error500 } from 'components/Error/Error500'

export default function ConsultarSaldoMobile(props) {
    const {
        cardsService,
        setUdCard,
        setLoad,
        errorCode,
        forceToken
    } = props
    const history = useHistory();

    // funciones para mostrar el modal
    const [showModal, SetShowModal] = useState(false);
    const showModalErrorCode = () => SetShowModal(true);
    const handleCloseErrorCode = () => SetShowModal(false);

    useEffect(()=>{
        if(errorCode <= 499){
            showModalErrorCode()
        }
    },[errorCode])

    const { dataSaldos, loading, upDateDataSaldos } = useConsultaSaldoData(cardsService)

    useEffect(()=>{
        setLoad(loading)
    },[loading])


    // redirecciona a movimientos de la tarjeta de credito
    const handleMovimientosTarjeta = () => {
        dataLayerButtons({eventName: "credito_movimientos"})
        history.push(`${BASE_PATH}${SUB_DIRECTORY}movimientos-tarjeta`);
    };
    // redirecciona a estado de cuenta
    const handleEstadoDeCuenta = () => {
        history.push(`${BASE_PATH}${SUB_DIRECTORY}solicitar-estado-cuenta`);
    };
    // redirecciona a pago express
    const irPagoExpress = () => {
        dataLayerButtons({eventName: "credito_pagoexpress"})
        history.push(`${BASE_PATH}${SUB_DIRECTORY}pago-express`);
    };
    // redirecciona a seccion mi tarjeta
    const handleMiTarjeta = () => {
        history.push(`${BASE_PATH}${SUB_DIRECTORY}mi-tarjeta`);
    };
    // redirecciona a pagar tarjeta
    const agregarTarjeta = () => {
        dataLayerButtons({eventName: "credito_agregartarjeta"})
        history.push(`${BASE_PATH}${SUB_DIRECTORY}agregar-tarjeta`);
    };
    const validarFolio = () => {
        history.push(`${BASE_PATH}${SUB_DIRECTORY}consultar-estatus-solicitud`);
    };
    const irSolicitud = () => {
        dataLayerButtons({eventName: "credito_solicitartarjeta"})
        history.push(`${BASE_PATH}${SUB_DIRECTORY}solicitud-credito-sears`);
    };
    
    
    removeStorage('cardendingPayment')
    removeStorage('noInternetPayment')
    // lleva a pagina pagar tarjeta
    const handlePagarTarjeta = () => {
        encodeStorage('cardendingPayment', dataSaldos.cardending)
        history.push(`${BASE_PATH}${SUB_DIRECTORY}pagar-tarjeta`);
    };

    // redirecciona a pagar en tienda
    // const pagarEnTienda = () => {
    //     history.push(`${BASE_PATH}${SUB_DIRECTORY}pagar-en-tienda`);
    // };


    // funcion para actualizar los datos
    //const updateServide = () => upDateDataSaldos()

    const [carEND, setCarEND] = useState(dataSaldos.titulo)
    useEffect(()=>{
        if(errorCode >= 499){
            setCarEND("Crédito SEARS")
        }else{
            setCarEND(dataSaldos.titulo)
        }

    },[dataSaldos])

    const [corte, setCorte] = useState(false)
    useEffect(()=>{
        if(Number(dataSaldos?.saldoBtnActive) >= 1){
            setCorte(true)
        }
        else{
            setCorte(false)
        }
    },[dataSaldos])

    return (
        <div className="homeMobile">
            <Header type="complete"/>
            <HeaderMobileCredito title={carEND} type="backFull" btnTypeR="floatMenu" />

            {errorCode >= 500
                ? <Error500 />
                :

                    <div className="contenedorGeneral top0">
                        <div className="boxInformacionPrincipal">
                            <div className="Boxdisponible">
                                <p className="cantidad">{dataSaldos.saldoDisponible}</p>
                                <p className="copy">Disponible para compras</p>
                            </div>

                            <div className="BoxTarjeta">
                                <div className="imaTarjetaConsulta">
                                    <div className="img" onClick={handleMiTarjeta}>
                                        <div className="numeroTarjeta">
                                            <span>{dataSaldos.numeroTarjeta}</span>
                                        </div>
                                        <div className="titular">
                                            <span>{dataSaldos.nombreTitular && dataSaldos.nombreTitular.toLowerCase()}</span>
                                        </div>
                                    </div>

                                    <NextCardButton setUdCard={setUdCard} />


                                </div>
                                <div className="boxOpcionesTarjeta">
                                    
                                    <CheckStatusCard  dataSaldos={dataSaldos}/>

                                    <div className="opcT">
                                        <button className="btnOpcT" onClick={handleMovimientosTarjeta}>Movimientos</button>
                                        <button className="btnOpcT borderLeftOpc" onClick={handleEstadoDeCuenta}>Estado de cuenta</button>
                                        <PagarPlan cardending={dataSaldos.cardending} typeButton={'inline'} saldoPay={dataSaldos.saldoBtnActive} />
                                    </div>
                                </div>

                                <RemoveCardSears
                                    dataSaldos={dataSaldos}
                                    setUdCard={setUdCard}
                                />
                            </div>
                        </div>

                        <div className="BoxDetalle">
                            <ul className="ulDetalle">
                                <div className="Boxtitle">
                                    <span >Resumen</span>
                                </div>

                                <li>
                                    <p className="pl">Mensualidad total:</p>
                                    <p className="pr">{dataSaldos.montoMensualidad}</p>
                                </li>
                                <li>
                                    <p className="pl">Mínimo a pagar:</p>
                                    <p className="pr">{dataSaldos.montoMinimo}</p>
                                </li>
                                <li>
                                    <p className="pl">Saldo nuevo al corte: </p>
                                    <p className="pr">{dataSaldos.montoNuevoCorte}</p>
                                </li>
                                <li>
                                    <p className="pl">Pago para no generar intereses: </p>
                                    <p className="pr">{dataSaldos.montoPagoNoGenerarIntereses}</p>
                                </li>
                                <li>
                                    {corte
                                        ?
                                            <>
                                                <p className="pl">Fecha límite de pago:</p>
                                            </>
                                        :
                                            <>
                                                <p className="pl">Fecha del próximo corte:</p>
                                            </>
                                    }
                                    <p className="pr">{dataSaldos.fechaLimite}</p>
                                </li>
                                <li>
                                    <p className="pl">Límite de crédito:</p>
                                    <p className="pr">{dataSaldos.montoLimiteCredito}</p>
                                </li>

                                <PagarPlan cardending={dataSaldos.cardending} saldoPay={dataSaldos.saldoBtnActive} />
                            </ul>

                            <div className="boxOpciones">
                                <p className="">¿Tienes otra tarjeta?</p>
                                <div className="boxButtons">
                                    <button className="btnAgregarRealizar" onClick={agregarTarjeta}>Agregarla</button>
                                    <button className="btnAgregarRealizar borderLeft" onClick={irPagoExpress}>Realizar pago express</button>
                                </div>
                            </div>

                            <div className="boxOpciones">
                                <p className="">¿Solicitar credito?</p>
                                <div className="boxButtons">
                                    <button className="btnAgregarRealizar" onClick={irSolicitud}>Solicita tu tarjeta</button>
                                    <button className="btnAgregarRealizar borderLeft" onClick={validarFolio}>Consultar solicitud</button>
                                </div>
                            </div>

                            {/* <div className="boxPagarTienda" onClick={pagarEnTienda}>
                                <p>Pagar en tienda con mi celular</p>
                            </div> */}
                            <Points cardsService={cardsService} />
                        </div>
                    </div>
            }
            {showModal &&
                <ModalError errorCode={errorCode} handleClose={handleCloseErrorCode} />
            }
        </div>
    )
}